<template>
    <div  class="pd-3 has-text-left w-60">
        <div class="has-text-left pd-y-2">
            <p class="is-size-6 th" v-if="component.display.label !== ''">{{component.display.label}}</p>
        </div>
        <div>
            <b-field 
                style="justify-content: center;"
                label="" 
                :class="{'is-marginless':component.options.multiple === false}"
                :message="valid[component.name].valid === true?component.validation.errorMsg:component.display.description" 
                :type="valid[component.name].valid === true?'is-danger':''"
            >
            <div>
               <div id="preview" >
                   <label for="uploadfile">
                    <div class="circle-img"v-if="checkImg()">
                       <img  class="haveimg" :src="imgPath+file.name" />
                    </div>
                    <div v-else class="noimg">
                        <div class="font">170 x 170</div>
                        <div class="circle-noimg"></div>
                    </div>
                    </label>
                </div>
                <div v-if="statusFile > 0" class="has-text-centered">
                  <span v-if="statusFile == 1" class="has-text-success">
                      <b-icon
                        icon="check"
                        pack="fas">
                      </b-icon> Upload Success
                  </span>
                  <span v-if="statusFile == 2" class="has-text-danger">
                    <b-icon
                      icon="times"
                      pack="fas">
                    </b-icon> Upload Fail
                  </span>
                </div>
                <div style="text-align:center">
                        <b-icon pack="fas"  icon="file-upload"  custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"
                                ></b-icon>
                    <label for="uploadfile">{{file.name ? file.name : 'No file chosen' | snippetMid}}</label>
                </div>
            </div>
            <input style="display:none"  type="file" id="uploadfile" name="uploadfile" @change="uploadFile(component.name,$event)">
        
                <!-- <b-upload drag-drop v-model="file"  @input="uploadFile(component.name,$event)" :multiple="component.options.multiple" class="form-upload"> -->
                    <!-- <div>
                    <section class="pd-x-10">
                        <div class="align-center is-flex " >
                            <b-icon
                                pack="fas"
                                icon="file-upload"
                                custom-class="fa-cloud-upload-alt mg-x-1 has-text-grey-dark"
                            ></b-icon>
                            
                            <p v-if="file.length !== 0 && component.options.multiple === false" class="mg-x-1">
                                <span                              
                                class="placeholder-th"
                                >{{file.name}}</span>
                            </p>
                            <p v-else class="mg-x-1 color-placeholder">
                                <span>{{component.display.placeholder}}</span>
                            </p>
                            <a class="button btn-upload icon-upload  mg-x-1 is-size-7">{{component.display.buttonText}}</a>
                        </div>
                    </section>
                    </div> -->
                <!-- </b-upload> -->
            </b-field>
            <!-- {{file}} -->
            <div v-if="component.options.multiple === true" class="tags">
                <span v-for="(item, index) in file"
                    :key="index"
                    class="tag is-primary" >
                    {{item.name}}
                    <button class="delete is-small"
                        type="button"
                        @click="deleteFile(index)">
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { HTTP,HTTPDynamic,HTTPMentor } from "@/axios";

export default {
    props:['component','input','fileUpload','delFile','value','valid'],
    data() {
        return {
            file:{name:''},
            statusFile:null,
            oldFile:[],
            url:null,
            imgPath:process.env.VUE_APP_IMG_PROFILE
        }
    },
    created() {
        this.checkImg()
    },
    computed:{
        user(){
            return this.$store.state.islogin
        }
    },
    methods: {
        checkImg(){
            if(this.input[this.component.name].name == '' ){
                if(this.user.detailUser[0].profilePic == ''){
                    return false
                }else{
                    this.file.name = this.user.detailUser[0].profilePic
                    this.setfileName(this.user.detailUser[0].profilePic,true)
                    this.$emit('checkValidateRequired',this.valid[this.component.name].name,this.valid[this.component.name].validation)
                    return true
                } 
            }else{
                console.log('this.input[this.component.name] else',this.input[this.component.name])
                if(this.input[this.component.name].name == ''){
                     this.file.name = this.input[this.component.name].name
                 }else{
                    this.file.name = this.input[this.component.name].name
                 }
                return true
                this.setfileName(this.file.name)
            }
           
            console.log('this.input[this.component.name]',this.input[this.component.name])
        },
        async uploadFile(name,event){
            console.log('eventeventeventevent',event.target.files[0])
            const formData = new FormData();

            console.log('this.filethis.file',this.file)
            if (this.component.options.multiple === true) {
                formData.append("file", event.target.files[0]);
            }else{ 
                formData.append("file", event.target.files[0]);
                this.delFile.push(this.input[this.component.name])
            }   
            await HTTPMentor.post(`upload/profilePic`,formData).then(res => {
                console.log("upload/file", res);  
                if (res.data.success) {
                    this.url = URL.createObjectURL(event.target.files[0]);
                    this.file.name = res.data.obj
                    this.input[this.component.name].name =res.data.obj
                    this.setfileName(res.data.obj,this.component.options.multiple)
                    this.$emit('checkValidateRequired',this.valid[name].name,this.valid[name].validation)
                    
                }else{
                    this.$dialog.alert('<p class="has-text-centered is-size-5">อัพโหลดไฟล์ล้มเหลว</p>');
                    if (this.component.options.multiple === false) {
                        this.statusFile = 0
                    }
                }
            })
            .catch(e => {
                console.log("upload/file/error",e);
                if (this.component.options.multiple === false) {
                    this.statusFile = 0
                }
                this.$dialog.alert('<p class="has-text-centered is-size-5">อัพโหลดไฟล์ล้มเหลว</p>');
            });
        },
        deleteFile(index){
            this.delFile.push(this.input[this.component.name][index])
            this.file.splice(index, 1)
            this.input[this.component.name].splice(index, 1)  
        },
        setfileName(nameFile,status){


            
        }
    },
}
</script>
<style scoped>
label{
    cursor: pointer;
}
#preview{
    display: flex; justify-content: center;
}

.circle-img{
  width:170px;
  height:170px;
  overflow:hidden;
  display:flex;
  border-radius: 50%;
  border:1px solid #ebebeb;
  justify-content: center;
  align-content: center;
}
.circle-img img{
    height: 100%;
    max-width: unset!important;
}
#preview .noimg{
    position:relative;
    float: left;
}
#preview .noimg .font{
    position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);
}
#preview .noimg .circle-noimg{
    border-radius: 50%; height: 170px !important; width: 170px !important; background:#cccccc; margin: 0 auto;
}
</style>
